import React from "react";
import style from "./Table.module.css";

const Table = () => {
  return (
    <>
      <div className={style.Main}>
        <table className={`${style.table}`}>
          <tr className="bg-white">
            <th>Total Courses:90</th>
            <th>Sorted by </th>
            <th>High Rated</th>
          </tr>

          <tr>
            <td>The new era of education</td>
            <td>4.8/5.0</td>
            <td>Prof. Raghu</td>
          </tr>
          <tr>
            <td>The new era of education</td>
            <td>4.8/5.0</td>
            <td>Prof. Raghu</td>
          </tr>
          <tr>
            <td>The new era of education</td>
            <td>4.8/5.0</td>
            <td>Prof. Raghu</td>
          </tr>
          <tr>
            <td>The new era of education</td>
            <td>4.8/5.0</td>
            <td>Prof. Raghu</td>
          </tr>
        </table>
      </div>
    </>
  );
};

export default Table;
